import { ProjectFileSection, ProjectFileUsage } from 'src/utils/enums'

export type UsageStatus =
  | 'MANQUANT'
  | 'INCOMPLET'
  | 'A_VERIFIER'
  | 'COMPLET'

export type FilterPill = 'ALL' | 'MISSING' | 'TO_VERIFY' | 'COMPLETE'

export type FileOrigin = 'project' | 'urban_analysis'

export type FileView = {
  id: string
  name: string
  mime_type: string
  size_bytes: number | null
  modified_at: string
  // Upload time — the order files are listed in within a usage.
  created_at: string
  status: 'ACCEPTED' | 'REJECTED' | null
  usage: ProjectFileUsage
  origin: FileOrigin
  comment?: string
}

export type UsageView = {
  key: ProjectFileUsage
  title: string
  section: ProjectFileSection
  required: number
  files: FileView[]
  tally: number
  status: UsageStatus
  is_visible: boolean
  is_editable: boolean
}

export type MatrixGroupView = {
  key: string
  title: string
  section: ProjectFileSection
  usages: ProjectFileUsage[]
  required: number
  files: FileView[]
  tally: number
  status: UsageStatus
  is_visible: boolean
  is_editable: boolean
}

export type UsageGroupView = UsageView | MatrixGroupView

export const isMatrixGroupView = (
  g: UsageGroupView
): g is MatrixGroupView => 'usages' in g

export type DocumentsViewState = {
  filter: FilterPill
  search: string
  groups: UsageGroupView[]
  unassigned_count: number
}
